import React, { useEffect } from 'react';
import {
  Form, Row, Col, Select, Radio,
} from 'antd';
import PropTypes from 'prop-types';
import './FlightPlusHotelForm.less';

const { Option } = Select;

/**
 * Flight Hotel Form:
 * This form is for the FlightHotel data. This includes the
 * hotel data.
 *
 * @author Luis Pulido
 */
const FlightHotelForm = (props) => {
  const {
    form, handleRequest, amenities,
  } = props;

  const {
    validateFields, setFieldsValue, getFieldDecorator, resetFields,
  } = form;

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        handleRequest(values);
      }
    });
  };

  useEffect(() => {
    if (amenities && Object.keys(amenities).length) {
      setFieldsValue({
        ...amenities,
      });
      handleRequest(amenities);
    } else {
      resetFields();
    }
  }, [amenities]);

  return (
    <div className="flight-hotel-form">
      <Form onSubmit={handleSubmit} onBlur={handleSubmit}>
        <Row gutter={[{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }, 20]}
        >
          <Col>
            <h2 className="form-title">Sobre el Hotel</h2>
          </Col>
          <Col span={4}>
            <Form.Item label="Estrellas Hotel">
              {getFieldDecorator('hotel_stars', {
                initialValue: 0,
                rules: [{
                  required: true,
                },
                ],
              })(
                <Select>
                  {Array.from(Array(6).keys()).map((c) => (
                    <Option key={c} value={c}>{c}</Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Desayuno">
              {getFieldDecorator('breakfast', { initialValue: false })(
                <Radio.Group>
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Todo Incluido">
              {getFieldDecorator('all_include', { initialValue: false })(
                <Radio.Group>
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Traslados">
              {getFieldDecorator('transfers', { initialValue: false })(
                <Radio.Group>
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Seguro de Viaje">
              {getFieldDecorator('travel_insurace', { initialValue: false })(
                <Radio.Group>
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

FlightHotelForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  handleRequest: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  amenities: PropTypes.object.isRequired,
};

const FlightHotelFormWrapper = Form.create({ name: 'flightHotelForm' })(FlightHotelForm);
export default FlightHotelFormWrapper;
